const packagingTestCampaign = 'packaging_8oz_20260915';
const packagingTestTags = {
  '8081554735169': { code: 'teal', tag: 'D32B52A0996FE36F0EB1050132149184' },
  '8081419829313': { code: 'white', tag: '55D12FBF35CD54123C108FF175D02870' },
  '7722522378305': { code: 'purple', tag: '1B3DA94FA5DD3AD9DFABE43371A15C88' },
};

const applyPackagingAttribution = (link) => {
  const entry = packagingTestTags[link.dataset.productId];
  if (!entry) return;

  const params = new URLSearchParams(window.location.search);
  const storageKey = `safolyte-packaging:${link.dataset.productId}`;
  let attributed = params.get('utm_campaign') === packagingTestCampaign && params.get('utm_content') === entry.code;
  try {
    if (params.has('utm_campaign') || params.has('utm_source')) {
      if (attributed) sessionStorage.setItem(storageKey, packagingTestCampaign);
      else sessionStorage.removeItem(storageKey);
    } else {
      attributed = sessionStorage.getItem(storageKey) === packagingTestCampaign;
    }
  } catch {}

  if (!attributed) return;
  link.href = `https://www.amazon.com/dp/B0G3Q926P8?maas=maas_adg_${entry.tag}_afap_abs&ref_=aa_maas&tag=maas`;
  link.dataset.packagingTest = entry.code;
};

const bindAmazonTracking = () => {
  document.querySelectorAll('[data-amazon-atc]').forEach((link) => {
    if (!(link instanceof HTMLAnchorElement)) return;
    applyPackagingAttribution(link);
    if (link.dataset.amazonTrackingBound === 'true') return;

    link.dataset.amazonTrackingBound = 'true';
    link.addEventListener('click', () => {
      if (typeof window.fbq !== 'function') return;

      if (link.dataset.packagingTest) {
        window.fbq('trackCustom', 'AmazonOutboundClick', {
          content_ids: [link.dataset.variantId || link.dataset.productId],
          packaging: link.dataset.packagingTest,
          campaign: packagingTestCampaign,
          destination_asin: 'B0G3Q926P8',
        });
        return;
      }

      const value = Number.parseFloat(link.dataset.price || '0');
      window.fbq('track', 'AddToCart', {
        content_ids: [link.dataset.variantId || link.dataset.productId],
        content_name: document.querySelector('h1')?.textContent?.trim() || document.title,
        content_type: 'product',
        value: Number.isFinite(value) ? value : 0,
        currency: link.dataset.currency || 'USD',
      });
    });
  });
};

if (!window.__safolyteAmazonTrackingBound) {
  window.__safolyteAmazonTrackingBound = true;

  document.addEventListener('variant:update', (event) => {
    const variant = event.detail?.resource;
    if (!variant) return;

    document.querySelectorAll('[data-amazon-atc]').forEach((link) => {
      link.dataset.variantId = String(variant.id || link.dataset.variantId || '');
      if (Number.isFinite(variant.price)) link.dataset.price = String(variant.price / 100);
    });
  });

  document.addEventListener('shopify:section:load', bindAmazonTracking);
}

bindAmazonTracking();
